module.exports = "<div class=\"y-form\" data-bind=\"css:textAlignCls\">\n  <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/index.html
// module id = 373
// module chunks = 0